import React from "react";

const LockIcon = ({ style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="20"
    viewBox="0 0 16 20"
    style={style}
  >
    <path
      id="LockIcon"
      d="M12,2A5.006,5.006,0,0,0,7,7V9H6a2,2,0,0,0-2,2v9a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V11a2,2,0,0,0-2-2H17V7A5.006,5.006,0,0,0,12,2ZM9,7a3,3,0,0,1,6,0V9H9Zm9,13H13V17.722a2,2,0,1,0-2,0V20H6V11H18l0,9Z"
      transform="translate(-4 -2)"
      fill="#51C3C7"
    />
  </svg>
);

export default LockIcon;
